import React, { Component } from "react";
import PropTypes from "prop-types";
import { Favorite, FavoriteBorder, PermDataSettingSharp } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { IconButton, Badge } from "@material-ui/core";
import { GREY } from "../../utils/color_utils";
import { GET_POINTS, CLEAR_POINTS, SHOW_TOAST } from "./../../store/actions/types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateLikePost } from "./../../store/actions/likesActions";
import LikedByDialog from "../Dialogs/LikedByDialog";
import { likesPoints, addMorePoints } from './../../store/actions/freshCardActions';
import { getRealPoints } from './../../store/actions/realPointsActions'
import { showToast } from './../../store/actions/toastAction'
import { POINT_CONFIG } from '../../utils/point_conversion_utils';
import { checkActivationStatus } from '../../utils/user_activation_utils';
import lodash from "lodash";
import firebase from './../../store/firebase';
import { _toArrayUsers } from './../../store/actions/commonActions'
import {
  isMobile,
  isBrowser
} from 'react-device-detect'
// import { updateDecorator } from "typescript";

const styles = theme => ({
  favoritesdiv: {
    color: "#fff",
    float: "left!important",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  },
  badge: {
    width: 40,
    color: "#676543",
    padding: "8px",
    fontSize: "8pt",
    border: `2px solid ${
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[900]
      }`,
    right: "-10px",
    backgroundColor: '#CDCCB6',
    pointer: "cursor"
  },
  mbadge: {
    width: 20,
    color: "#676543",
    padding: "5px",
    fontSize: "8pt",
    border: `1px solid ${
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[900]
      }`,
    right: "1px",
    backgroundColor: '#CDCCB6',
    pointer: "cursor"
  }
});

// Get the user thats logged in

// TODO: Call it Liking
class LikeButton extends Component {
  state = {
    //liked: false,
    likeCount: 0,
    userLoggedIn: {},
    openLikedByDialog: null,
    pointsData: 0
  };

  static postTypes = ["thoughts", "articles", "podcasts", "videos"];

	makeid = (length) => {
		var result           = '';
		var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		var charactersLength = characters.length;
		for ( var i = 0; i < length; i++ ) {
			result += characters.charAt(Math.floor(Math.random() * 
	charactersLength));
		}
		return result;
	}

  getLikeUnlike(props) {
    for (let x in props) {
      return props[x].likeUnlike
    }
  }

  getRPoints(props) {
    for (let x in props) {
      return props[x].points
    }
  }

  pointsPass = (dbPoints, realPoints) => {
    var pass = false;
    if (dbPoints < realPoints) {
      if (parseInt(realPoints) - parseInt(dbPoints) < 2) { 
        pass = true;
      }
    } else
    {
      if (parseInt(dbPoints) - parseInt(realPoints) < 2) { //too big - CANCEL
        pass = true;
      } 
    }
    return pass;
  }


  getPoints = async (post, realPoints, realPointsy, isLiking) => {
    const { postType, postID, userdata } = this.props;
    let authorPoints = isLiking ? POINT_CONFIG.AUTHOR_POINTS : -POINT_CONFIG.AUTHOR_POINTS;
    let likerPoints = isLiking ? POINT_CONFIG.LIKE_POINTS : -POINT_CONFIG.LIKE_POINTS;
    // Ledger path to ensure reversals use original award values
    const ledgerRef = firebase.database.ref(`likesLedger/${this.props.postID}/${userdata.userID}`);
    try {
      if (isLiking) {
        // Store award amounts for exact future reversal
        await ledgerRef.set({ authorPoints, likerPoints, ts: Date.now() });
      } else {
        const snap = await ledgerRef.once('value');
        if (snap.exists()) {
          const v = snap.val() || {};
          // Use stored amounts (ensure negative on reversal)
          authorPoints = -Math.abs(Number(v.authorPoints || authorPoints));
          likerPoints = -Math.abs(Number(v.likerPoints || likerPoints));
          // Clear ledger after reversal
          try { await ledgerRef.remove(); } catch (_) {}
        }
      }
    } catch (_) {}

    // Points for the post author
    let authorData = { 
      uid: this.props.post.uid,
      userID: this.props.post.journalUserID,
      pointsCurrent: realPoints,
      ypointsCurrent: realPointsy,
      leadID: this.props.postID,
      leadPoints: this.props.post.leadPoints ? this.props.post.leadPoints : 0,
      pointsAdded: authorPoints,
      trailID: this.makeid(10),
      companyName: this.props.post.companyName,
      firstName: this.props.post.journalUserName,
      lastName: "empty",
      title: this.props.post.title,
      actionType: "Like received",
      actionDesc: "LEAD like received",
      currentUser: userdata.userID,
      groupid: this.props.post.groupid ? this.props.post.groupid : ''
    };

    // Only allocate points if different people
    if (userdata.userID !== this.props.post.journalUserID && authorData.pointsCurrent) {
      
      // Check activation status for both owner and user
      const ownerData = {
        execmember: this.props.post.execmember,
        userType: this.props.post.userType,
        points: realPoints
      };
      
      const userData = {
        execmember: userdata.execmember,
        userType: userdata.userType,
        points: userdata.points
      };
      
      const { ownerActivated, userActivated, scenario } = checkActivationStatus(ownerData, userData);
      
      // Scenario 1: Owner activated & user activated → normal 70/30% distribution
      // Scenario 2: Owner activated & user NOT activated → Owner gets 70%, user gets nothing  
      // Scenario 3: Owner not activated → nobody gets points
      
      if (scenario === 'both_activated' || scenario === 'owner_only') {
        // Give points to the owner (author) in both scenarios
        console.log('likesPoints goto function: ', authorData);
        this.props.likesPoints(authorData);
      }
      
      if (scenario === 'both_activated') {
        // Give points to the liker when both are activated.
        // Fetch current points from DB to ensure correct unit scaling; fallback to 0 if missing.
        firebase.database.ref('user/' + userdata.uid).once('value', (likerSnapshot) => {
          const likerCurrentPoints = likerSnapshot.exists() && likerSnapshot.val().points ? likerSnapshot.val().points : 0;
          const likerCurrentPointsy = likerSnapshot.exists() && likerSnapshot.val().pointsy ? likerSnapshot.val().pointsy : 0;

          let likerData = {
            uid: userdata.uid,
            userID: userdata.userID,
            pointsCurrent: likerCurrentPoints,
            ypointsCurrent: likerCurrentPointsy,
            leadID: this.props.postID,
            leadPoints: 0, // Liker doesn't affect lead points
            pointsAdded: likerPoints,
            trailID: this.makeid(10),
            companyName: userdata.companyName,
            firstName: userdata.firstName,
            lastName: userdata.lastName || "empty",
            title: "Like given",
            actionType: "Like given",
            actionDesc: "LEAD like given",
            currentUser: userdata.userID,
            groupid: this.props.post.groupid ? this.props.post.groupid : ''
          };

          this.props.addMorePoints({ ...likerData, forceAward: true });
        });
      }
    }

    if (this.props.showLeadb) {
      this.props.showLeadb(this.props.post);
    }
  };

  handleUpdatePostLike = async (post, realPoints) => {
    const { postType, postID, userdata } = this.props;

     let data, ydata = 0;
     try {
     if (post.uid) {
      //GET REAL POINTS DIRECTLY FROM DATABASE
      await firebase.database
      .ref('user/' + post.uid)
      .once('value', function (xdata) {
        try {
        if (xdata.val().points) {
          data = xdata.val().points
          ydata = xdata.val().pointsy
        }
       } catch (error) {
        // Error getting user points
      }
     }
    )
     }
    } catch (error) {
      // Error connecting to database
    }

    // Determine whether this click is a like or an unlike BEFORE toggling
    const isLiking = !this.state.liked;

    // Create params BEFORE toggling state to ensure correct like/unlike value
    const params = {
      postType: postType,
      postID: postID,
      likeUnlike: isLiking ? "like" : "unlike"
    };

    // Optimistically update local like state & count for immediate UI feedback
    this.setState(prevState => {
      const currentCount = typeof prevState.likeCount === "number" ? prevState.likeCount : 0;
      const nextCount = currentCount + (isLiking ? 1 : -1);
      return {
        liked: !prevState.liked,
        likeCount: nextCount < 0 ? 0 : nextCount
      };
    });

    // Save like to Firebase
    this.props.updateLikePost(params, post, this.props.userdata);  

    // Award points
    await this.getPoints(post, data, ydata, isLiking);
  };

  handleLikeClick = (e, post) => {
    e.preventDefault()
    this.handleUpdatePostLike(post);
  };

  handleCloseActivityDialog = () => {
    this.setState({
      openLikedByDialog: null
    });
  };

  openLikedBy = () => {
    this.setState({
      openLikedByDialog: true
    });
  };

  componentDidMount() {
    const { userdata, post } = this.props;
    
    let liked = post.likesData && post.likesData[userdata.userID];

    // Derive initial like count from the post
    let initialLikeCount = 0;
    try {
      if (post && post.likesData && typeof post.likesData === "object") {
        initialLikeCount = Object.keys(post.likesData).length;
      } else if (typeof post.likeCount !== "undefined") {
        initialLikeCount = Number(post.likeCount) || 0;
      } else if (typeof post.countLikes !== "undefined") {
        initialLikeCount = Number(post.countLikes) || 0;
      }
    } catch (e) {
      initialLikeCount = 0;
    }
    
    this.setState(prevState => ({
      userLoggedIn: userdata,
      liked: liked,
      likeCount: initialLikeCount
    }));
  }

  componentDidUpdate(prevProps) {
    // If parent/Redux sends an updated post with new likes data, keep local state in sync
    const prevPost = prevProps.post || {};
    const currPost = this.props.post || {};
    
    // Check if likes data has actually changed by comparing the postID and likesData
    const prevLikesData = prevPost.likesData || {};
    const currLikesData = currPost.likesData || {};
    const prevPostId = prevPost.key || prevPost.id;
    const currPostId = currPost.key || currPost.id;
    
    // If same post and same likes data, no need to update
    if (prevPostId === currPostId && JSON.stringify(prevLikesData) === JSON.stringify(currLikesData)) {
      return;
    }

    const { userdata } = this.props;
    let liked = currLikesData && userdata
      ? !!currLikesData[userdata.userID]
      : false;

    let likeCount = 0;
    try {
      if (currPost && currLikesData && typeof currLikesData === "object") {
        likeCount = Object.keys(currLikesData).length;
      } else if (typeof currPost.likeCount !== "undefined") {
        likeCount = Number(currPost.likeCount) || 0;
      } else if (typeof currPost.countLikes !== "undefined") {
        likeCount = Number(currPost.countLikes) || 0;
      }
    } catch (e) {
      // keep existing likeCount on error
    }

    // Always update state to reflect Firebase data
    if (likeCount !== this.state.likeCount || liked !== this.state.liked) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ likeCount, liked });
    }
  }


  render() {
    const { classes, post } = this.props;
    // Prefer local likeCount so the badge updates immediately after clicking
    let badgeCount = this.state.likeCount;
    if (typeof badgeCount === "undefined" || badgeCount === null) {
      if (post && post.likesData && typeof post.likesData === "object") {
        badgeCount = Object.keys(post.likesData).length;
      } else if (typeof post.likeCount !== "undefined") {
        badgeCount = Number(post.likeCount) || 0;
      } else if (typeof post.countLikes !== "undefined") {
        badgeCount = Number(post.countLikes) || 0;
      } else {
        badgeCount = 0;
      }
    }
    return (
      <div className={classes.favoritesdiv}>
        <div>
          <IconButton
            style={{
              color: "",
              backgroundColor: '#CDCCB6',
              userSelect: "none"
             }}
            aria-label="Add to favorites"
            onClick={() => this.handleUpdatePostLike(post, this.data)}
          >
            {this.state.liked ? (                              
                 <Favorite style={{ width: "12px", height: "12px" }} />
            ) : (
                <FavoriteBorder style={{ width: "12px", height: "12px" }} />
              )}
          </IconButton>
        </div>
        <div style={{ cursor: "pointer" }}>
       
          <Badge
            onClick={this.openLikedBy}
            invisible={false}
            badgeContent={
               badgeCount
             }

            classes={{ badge: isMobile ? classes.mbadge : classes.badge }}
            style={{ cursor: "pointer" }}
          />
          
          {this.state.openLikedByDialog ? (
            <LikedByDialog
              open={this.state.openLikedByDialog}
              likeData={post.likesData}
              onCloseLikedBy={this.handleCloseActivityDialog.bind(this)}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

LikeButton.propTypes = {
  post: PropTypes.object.isRequired,
  postType: PropTypes.string.isRequired,
  postID: PropTypes.string.isRequired
};

const Liking = withStyles(styles, { withTheme: true })(LikeButton);

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      updateLikePost,
      likesPoints,
      addMorePoints,
      getRealPoints,
      showToast
    },
    dispatch
  )
});

const mapStateToProps = (state, ownProps) => {
  return {
    likes: state.likes,
    userdata: state.userDialog.userDetails[0],
    rrpoints: state.realpoints.realpoints,
    //thoughts: state.thoughts.ilead
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Liking);
